import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzToggleSwitchModule } from '@blk/daisy/elements/selection-controls';
import { DzModalModule } from '@blk/daisy/modules/modals';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { CustomAdvisoryFeeDialogButtonComponent } from './advisory-fee-button/custom-advisory-fee-dialog-button/custom-advisory-fee-dialog-button.component';
import { CustomizeAdvisoryFeeDialogComponent } from './advisory-fee-button/customize-advisory-fee-dialog/customize-advisory-fee-dialog.component';
import { AdvisoryFeeChangeInfoDialogComponent } from './advisory-fee-change-info-dialog/advisory-fee-change-info-dialog.component';
import { CustomAdvisoryFeeService } from './services/custom-advisory-fee.service';

@NgModule({
	declarations: [
		CustomAdvisoryFeeDialogButtonComponent,
		CustomizeAdvisoryFeeDialogComponent,
		AdvisoryFeeChangeInfoDialogComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		CoreModule,
		CwpNgFrameworkModule,
		ReactiveFormsModule,
		DomModule,
		DzButtonModule,
		DzToggleSwitchModule,
		AnalyticsModule,
		DomModule,
		GenericDirectivesModule,
		DzModalModule
	],
	providers: [
		CustomAdvisoryFeeService
	],
	exports: [
		CustomAdvisoryFeeDialogButtonComponent,
		CustomizeAdvisoryFeeDialogComponent,
		AdvisoryFeeChangeInfoDialogComponent
	]
})
export class AdvisoryFeeModule { }
